export const rangeTypes = [
  { slug: 'hair-care', contentType: 'productRangeHairCare' },
  { slug: 'hair-color', contentType: 'productRangeHairColor' },
  { slug: 'make-up', contentType: 'productRangeMakeUp' },
  { slug: 'mens', contentType: 'productRangeMens' },
  { slug: 'perm', contentType: 'productRangePerm' },
  { slug: 'skin-body-care', contentType: 'productRangeSkinBodyCare' },
  { slug: 'styling', contentType: 'productRangeStyling' },
];

const contentTypeToSlugMap = rangeTypes.reduce(
  (acc, range) => ({
    ...acc,
    [range.contentType]: range.slug,
  }),
  {}
);
export const contentTypeToSlug = contentType => contentTypeToSlugMap[contentType];

const slugToContentTypeMap = rangeTypes.reduce(
  (acc, range) => ({
    ...acc,
    [range.slug]: range.contentType,
  }),
  {}
);
export const slugToContentType = slug => slugToContentTypeMap[slug];



// WEBPACK FOOTER //
// ./src/pages/RangePage/rangeNameConverter.js